import mixitup from 'mixitup';
import mixitupPagination from './vendor/mixitup-pagination.min';
import mixitupMultifilter from './vendor/mixitup-multifilter.min'; // import Dropdown from './vendor/dropdown';
// const mixitupMultifilter = './vendor/mixitup-multifilter.min';

var Filtering = function Filtering() {
  mixitup.use(mixitupPagination);
  mixitup.use(mixitupMultifilter);
  var loadmore = document.querySelector('.transactions-loadmore');
  var filters = document.querySelectorAll( // '.Companies-filterWrapper button'
  '.Transactions--filter select');
  var loadmoreSettings = loadmore ? {
    limit: loadmore.dataset.loadmore,
    hidePageListIfSinglePage: true
  } : {};
  var mixer = mixitup('.transactions-filtering', {
    pagination: loadmoreSettings,
    multifilter: {
      enable: true // enable the multifilter extension for the mixer

    },
    animation: {
      duration: 250,
      nudge: true,
      easing: 'ease-out',
      reverseOut: false,
      effects: 'fade'
    } // control: {
    //     toggleDefaults: "all"
    // },
    // callbacks: {
    //     onMixStart: () => {
    //         var element = document.getElementById("noCheck");
    //         if (element) {
    //             element.classList.remove("greyOut");
    //         }
    //     },
    //     // onMixEnd: state => {
    //     //     window.dispatchEvent(new Event("resize"));
    //     //     var addOns = state.matching.filter(addOn =>
    //     //         addOn.classList.contains("add_on")
    //     //     );
    //     //     if (!addOns.length) {
    //     //         var element = document.getElementById("noCheck");
    //     //         element.classList.add("greyOut");
    //     //     }
    //     //     return loadmore ? updateLoadmore(loadmore) : null;
    //     // }
    //     onMixFail: () => {
    //         var element = document.getElementById("noCheck");
    //         element.classList.add("greyOut");
    //     }
    // }

  });

  var updateLoadmore = function updateLoadmore(ownLoadmore) {
    var limit = mixer.getState().activePagination.limit;

    var _mixer$getState = mixer.getState(),
        totalMatching = _mixer$getState.totalMatching;

    if (limit > totalMatching) {
      ownLoadmore.classList.add('is-disabled');
      ownLoadmore.disabled = true;
    } else if (ownLoadmore.disabled) {
      ownLoadmore.classList.remove('is-disabled');
      ownLoadmore.disabled = false;
    }
  };

  if (loadmore) {
    if (mixer.getState().totalTargets < loadmore.dataset.loadmore) loadmore.style.display = 'none';
    loadmore.addEventListener('click', function () {
      mixer.paginate({
        limit: mixer.getState().activePagination.limit + 8
      });
      return updateLoadmore(loadmore);
    });
    updateLoadmore(loadmore);
  }

  if (document.querySelector('[data-filter-group]')) {
    mixer.setFilterGroupSelectors('services', '.mix');
    mixer.setFilterGroupSelectors('sectors', '.mix');
    mixer.parseFilterGroups();
  }

  Array.from(filters).forEach(function (item) {
    return item.addEventListener('change', function () {
      var filterValues = Array.from(filters).map(function (cur) {
        return cur.options[cur.selectedIndex].value;
      }).join('');
      filterValues = filterValues || 'all';
      return mixer.filter(filterValues);
    });
  }); // -------------------------------------
  // will remove if using native styles
  // Dropdown({
  //   selector: '.CustomDropdown',
  //   firstAsLabel: true
  // });
  // -------------------------------------

  var getParameterByName = function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[]]/g, '$&');
    var regex = new RegExp("[?&]".concat(name, "(=([^&#]*)|&|#|$)"));
    var results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  };

  var service = getParameterByName('service');

  if (service) {
    var serviceClass = ".".concat(service);
    var option = document.querySelector('.CustomDropdown-list li[data-value="' + serviceClass + '"]'); // This is really bad
    // :(

    option.click();
    document.body.click(); // mixer.filter(industryClass);
  } // -------------------------------------
  // const getParameterByName = (name, url) => {
  //     if (!url) url = window.location.href;
  //     name = name.replace(/[[]]/g, "$&");
  //     let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
  //         results = regex.exec(url);
  //     if (!results) return null;
  //     if (!results[2]) return "";
  //     return decodeURIComponent(results[2].replace(/\+/g, " "));
  // };
  // let industry = getParameterByName("type");
  // if (industry) {
  //     let industryClass = "." + industry;
  //     let option = document.querySelector(
  //         '.CustomDropdown-list li[data-value="' + industryClass + '"]'
  //     );
  //     // This is really bad
  //     // :(
  //     option.click();
  //     document.body.click();
  //     // mixer.filter(industryClass);
  // }

};

export default Filtering;